"use client";
import { Landmark, Building2, Vote, User, TrendingUp, Shield } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whoItsFor as data } from "@/lib/data/platform-dashboard";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  Landmark, Building2, Vote, User, TrendingUp, Shield,
};

export function WhoItsFor() {
  return (
    <Section id="who-its-for" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-denim)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.segments.map((s, i) => {
            const Icon = iconMap[s.icon] ?? Building2;
            return (
              <Reveal key={s.title} delay={i * 60}>
                <div
                  className="glass rounded-2xl p-6 h-full"
                  style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-${s.accent}) 12%, transparent)` }}
                >
                  <span
                    className="grid place-items-center h-11 w-11 rounded-xl"
                    style={{
                      background: `color-mix(in oklch, var(--color-${s.accent}) 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-${s.accent}) 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-5 w-5" style={{ color: `var(--color-${s.accent})` }} />
                  </span>
                  <h3 className="mt-4 text-lg">{s.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
